import React from "react";

import PrimaryButton from 'components/partials/buttons/primary-button';

// import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";

type StandardContentProps = {
  content?: string;
  link?: Queries.LinkBlockFragment;
  fullWidth?: boolean;
};

const StandardContent: React.FC<React.PropsWithChildren<StandardContentProps>> = ({ content, link, children, fullWidth = false }) => {

  const linkData = getLinkDataFromDato(link?.link);

  const buttonProps = linkData ? {
    buttonText: linkData.label || 'Error: Missing Button Text',
    buttonUrl: linkData.url || "#",
    target: linkData.target || "_self",
    plain: true
  } : undefined;

  return (
    <div className="pattern pattern--standard-content">
      <div className={`container ${!fullWidth ? 'container--md' : ''}`}>
        {children}
        {content && <div className="rtecontent" dangerouslySetInnerHTML={{ __html: content }} />}
        {buttonProps && <PrimaryButton {...buttonProps} />}
      </div>
    </div>
  );
};

export default StandardContent;